import { useDutchieLocation } from './useDutchieLocation';

export const usePromobar = () => {
  const lang = useDutchieLocation();
  const defaultText = 'FREE DELIVERY ON ALL ORDERS OVER $30';
  const torontoText = 'FREE DELIVERY ON ALL ORDERS OVER $50';
  return lang === 'The House of Cannabis - Toronto' ? torontoText : defaultText;
};
